import { MappedContexts, Context } from "../types/Context";

export const normalizeContexts = (contexts: Context[]) => {
    const mappedContexts: MappedContexts = {}
    for (let context of contexts) {
        mappedContexts[context.id] = context
    }
    return mappedContexts;
}